module.exports = __webpack_public_path__ + "static/media/icon-close.7bc01b0e.svg";